<div class="text-center" *ngIf="involvements_loading">
  <i class="fas fa-spinner fa-pulse fa-3x"></i>
</div>
<div *ngIf="!involvements_loading">
  <nav ngbNav #navRoles="ngbNav" class="nav-tabs">
    <ng-container ngbNavItem>
      <a ngbNavLink>Group By Role</a>
      <ng-template ngbNavContent>
        <h3 class="section-title my-3 font-weight-normal">Clients</h3>
        <app-involvement [involvement]="involvement" (involvementChange)="involvementChanged(involvement, $event)" *ngFor="let involvement of clientInvolvements"></app-involvement>
        <h3 class="section-title my-3 font-weight-normal">Grouped</h3>
        <div class="row">
          <div class="col-md-3" style="border-right: 1px solid rgba(0, 0, 0, 0.125)">
            <ul class="nav nav-pills flex-column">
              <li class="nav-item" *ngFor="let role of allRoles">
                <a [class]="'nav-link' + (selectedRole == role ? ' active' : '')" (click)="selectedRole = role; setInvolvementsByRole(role)" href="javascript: void(0)">{{ role }}</a>
              </li>
            </ul>
          </div>
          <div class="col-md-9">
            <h3 class="mt-2 font-weight-normal">
              {{ selectedRole }}
            </h3>
            <hr />
            <div *ngIf="selectedRole">
              <app-involvement [involvement]="involvement" (involvementChange)="involvementChanged(involvement, $event)" *ngFor="let involvement of selectedRoleInvolvements"></app-involvement>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
    <ng-container ngbNavItem>
      <a ngbNavLink>Full (Alphabetical)</a>
      <ng-template ngbNavContent>
        <div class="py-2"></div>
        <app-involvement [involvement]="involvement" (involvementChange)="involvementChanged(involvement, $event)" *ngFor="let involvement of involvements"></app-involvement>
      </ng-template>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="navRoles"></div>
</div>
